import type { RealtimeNotification } from './realtime.js';

const ENTITY_NAV: Record<string, string> = {
  account: '/app/crm/account',
  contact: '/app/crm/contact',
  lead: '/app/crm/lead',
  opportunity: '/app/crm/opportunity',
  quote: '/app/crm/quote',
  iws_sinosure: '/app/crm/iws_sinosure',
  iws_deliverproject: '/app/crm/iws_deliverproject',
};

function internalPath(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('/app/') || trimmed.startsWith('/go?')) return trimmed;
  return null;
}

function textValue(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function payloadTargetId(payload: RealtimeNotification['payload'], entity?: string): string | null {
  if (!payload) return null;
  const generic =
    textValue(payload.targetId) ??
    textValue(payload.targetEntityId) ??
    textValue(payload.entityId) ??
    textValue(payload.id);
  if (generic) return generic;
  if (entity === 'account') return textValue(payload.accountId) ?? textValue(payload.accountid);
  if (entity === 'opportunity') {
    return (
      textValue(payload.opportunityId) ??
      textValue(payload.opportunityid) ??
      textValue(payload.iws_opportunityid)
    );
  }
  if (entity === 'lead') return textValue(payload.leadId) ?? textValue(payload.leadid);
  if (entity === 'contact') return textValue(payload.contactId) ?? textValue(payload.contactid);
  if (entity === 'quote') return textValue(payload.quoteId) ?? textValue(payload.quoteid);
  return null;
}

export function notificationTargetPath(n: RealtimeNotification): string | null {
  const actionUrl = internalPath(n.payload?.actionUrl);
  if (actionUrl) return actionUrl;

  const entity = textValue(n.targetEntity)?.toLowerCase();
  const taskId = textValue(n.targetId) ?? payloadTargetId(n.payload, entity ?? undefined) ?? n.id;
  if (
    n.kind === 'approval' ||
    entity === 'approval' ||
    entity === 'task' ||
    entity === 'iws_approvetask'
  ) {
    return taskId ? `/app/crm/inbox?taskId=${taskId}` : '/app/crm/inbox';
  }

  if (!entity) return null;
  const targetId = textValue(n.targetId) ?? payloadTargetId(n.payload, entity);
  const base = ENTITY_NAV[entity];
  return base && targetId ? `${base}/${targetId}` : null;
}
